import _objectSpread from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useButtonProps } from '@restart/ui/Button';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultProps = {
  variant: 'primary',
  active: false,
  disabled: false
};
var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
    bsPrefix = _ref.bsPrefix,
    variant = _ref.variant,
    size = _ref.size,
    active = _ref.active,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, ["as", "bsPrefix", "variant", "size", "active", "className"]);
  var prefix = useBootstrapPrefix(bsPrefix, 'btn');
  var _useButtonProps = useButtonProps(_objectSpread({
      tagName: as
    }, props)),
    _useButtonProps2 = _slicedToArray(_useButtonProps, 2),
    buttonProps = _useButtonProps2[0],
    tagName = _useButtonProps2[1].tagName;
  var Component = tagName;
  return /*#__PURE__*/_jsx(Component, _objectSpread({}, buttonProps, props, {
    ref: ref,
    className: classNames(className, prefix, active && 'active', variant && "".concat(prefix, "-").concat(variant), size && "".concat(prefix, "-").concat(size), props.href && props.disabled && 'disabled')
  }));
});
Button.displayName = 'Button';
Button.defaultProps = defaultProps;
export default Button;